import React from 'react';
import { motion } from 'motion/react';
import './Ribbons.css';
import { FiZap, FiStar, FiClock } from 'react-icons/fi';

// A shared shimmer component to reuse across all tags
const Shimmer = () => (
  <motion.div
    className="shimmer-overlay"
    initial={{ x: '-100%' }}
    animate={{ x: '100%' }}
    transition={{
      repeat: Infinity,
      duration: 2, // Adjust speed (seconds)
      ease: "linear",
      repeatDelay: 1 // Delay between sweeps
    }}
  />
);

export const FeaturedRibbon = ({ text = 'FEATURED' }) => (
  <div className="qinto-ribbon-base shape-arrow bg-featured">
    <Shimmer />
    <span className="ribbon-content">{text}</span>
  </div>
);

export const NewListingRibbon = ({ text = 'NEW' }) => (
  <div className="qinto-ribbon-base shape-arrow bg-new">
    <Shimmer />
    <span className="ribbon-content">
      <FiClock className="ribbon-icon" />
      {text}
    </span>
  </div>
);

export const TrendingTag = ({ text = 'TRENDING' }) => (
  <div className="qinto-ribbon-base shape-slant bg-trending">
    <Shimmer />
    <span className="ribbon-content">
      <FiZap className="ribbon-icon" />
      {text}
    </span>
  </div>
);

export const BestsellerTag = ({ text = 'BESTSELLER' }) => (
  <div className="qinto-ribbon-base shape-slant bg-bestseller">
    <Shimmer />
    <span className="ribbon-content">
      <FiStar className="ribbon-icon" />
      {text}
    </span>
  </div>
);